import { ActivatedRouteSnapshot, ViewTransitionInfo } from '@angular/router';

/** Pages that animate into each other: the employees Cards and List views. */
export const ANIMATED_VIEWS: readonly (readonly string[])[] = [['/employees/card-view', '/employees/grid-view']];

/** The path a route snapshot stands for, e.g. "/employees/card-view" (no query or fragment). */
export function snapshotPath(snapshot: ActivatedRouteSnapshot | null | undefined): string {
  const segments: string[] = [];
  for (let route = snapshot; route; route = route.firstChild) {
    segments.push(...route.url.map((segment) => segment.path));
  }
  return '/' + segments.join('/');
}

/** True when the navigation goes from one view of a group to another one of the same group. */
export function isAnimatedNavigation(from: string, to: string): boolean {
  return from !== to && ANIMATED_VIEWS.some((group) => group.includes(from) && group.includes(to));
}

/**
 * The router starts a view transition for every navigation; only the switches between views of a group
 * (Cards / List) keep it, every other page changes as before.
 */
export function animateOnlyBetweenViews({ transition, from, to }: ViewTransitionInfo): void {
  if (!isAnimatedNavigation(snapshotPath(from), snapshotPath(to))) {
    // A skipped transition rejects its "ready" promise; nobody waits for it, so the rejection is expected.
    transition.ready.catch(() => undefined);
    transition.skipTransition();
  }
}
